export default __webpack_public_path__ + "static/img/11.822c38e.png";